import { createBaseAction } from '@essent/common';

export const selectContractGroupId = createBaseAction<string | undefined>(
  '[Contract Groups] Select contract group'
);
